export default "__VITE_ASSET__dda33bc3__"